import Cookies from 'js-cookie';
import { checkXcx } from "@utils/checkXcx";
import API_ENV from "./API_ENV";
import { BFD_checkApp } from './bfdApp';
import { getExchangePlatformCode } from './gioIndex';
/**
 * 返回一个范围
 * @param  {Number} num 整数
 * @param  {Number} min 最小值
 * @param  {Number} max 最大值
 * @return {Number}
 */
export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
/**
 * 是否是统一商城 true代表是
 */
export function checkUnifyShop() {
  if (window.dfWebUnifyShop === true) {
    return true
  } else {
    return false
  }
}

/**
 * @param { String } path 将要跳转的路由地址
 * @return { String } 跳转的url
 */
export function getJumpPath(path) {
  const city = localStorage.getItem("city")
    ? localStorage.getItem("city").split(",")[0]
    : getQueryString('city') ? getQueryString('city')
    : "145";
  const union = unionFlag() || sessionStorage.getItem('UNION');
  // 如果是工会拼上union,否则只拼city
  const url = union
    ? `${path}?city=${city}&union=${union}`
    : `${path}?city=${city}`;
  return url;
}


/**
 * 判断当前是否是英文环境
 */
 export function unionEnState() {
  const unionF = unionFlag() || window.sessionStorage.getItem('dffl_union');
  let flag = false;
  if (Cookies.get('df_lang') === 'en-US' && unionF) {
    flag = true;
  }
  return flag;
}

/**
 * 获取请求参数名对应的值
 * @param  {String} name 参数名字
 * @return {String}
 */
export function getQueryString(name) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return "";
}
/**
 * 获取cookie
 * @param {String} sKey 获取cookie对应的名字
 * @return {String | Object}
 */
export function getCookie(sKey) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          "(?:(?:^|.*;)\\s*" +
          encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
          "\\s*\\=\\s*([^;]*).*$)|^.*$"
        ),
        "$1"
      )
    ) || null
  );
}

/**
 * 判断某cookie是否存在
 * @param {String} sKey cookie的名字
 * @return {Boolean}
 */
export function hasCookie(sKey) {
  return new RegExp(
    "(?:^|;\\s*)" +
    encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") +
    "\\s*\\="
  ).test(document.cookie);
}

/**
 * 锚点定位方法
 * anchorName: 元素id [string]
 */
export function scrollToAnchor(anchorName) {
  if (anchorName) {
    const anchorElement = document.getElementById(anchorName);
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: "smooth" });
    }
  }
}
// 防抖
export const debounce = (fn, ms = 0) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
/*对一串数字部分隐藏处理
str:要处理的字符串
frontLen：前面要保留的位数
endLen： 后面要保留的位数
*/
export const plusXing = (str, frontLen, endLen) => {
  let len = str.length - frontLen - endLen;
  let xing = "";
  for (var i = 0; i < len; i++) {
    xing += "*";
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
};

export const getIcon = () => {
  let isUnion = window.location.host.split(".")[0] === "corp";
  if(checkUnifyShop()){
    isUnion = checkUnifyShop()
  }
  // const icon = isUnion ? require('@assets/imgs/fudou.png') : getCookie('UNION_ICON');
  const icon =
    isUnion && getCookie("UNION_ICON") !== "null"
      ? getCookie("UNION_ICON") || require("@assets/imgs/fudou.png")
      : require("@assets/imgs/fudou.png");
  return icon;
};

export const getIconName = () => {
  let isUnion = window.location.host.split(".")[0] === "corp";
  if(checkUnifyShop()){
    isUnion = checkUnifyShop()
  }
  // const icon = isUnion ? require('@assets/imgs/fudou.png') : getCookie('UNION_ICON');
  const icon =
    isUnion && getCookie("UNION_NAME") !== "null"
      ? getCookie("UNION_NAME") || TLang("福豆", 'card')
      : TLang("福豆", 'card');
  return icon;
};

export const getScaleMoney = (money) => {
  let isUnion = window.location.host.split(".")[0] === "corp";
  if(checkUnifyShop()){
    isUnion = checkUnifyShop()
  }
  // const scaleMoney = isUnion ? money : getCookie('UNION_SCALE') * money * 2;
  const scaleMoney = isUnion ? getCookie("UNION_SCALE") * money : money;
  return scaleMoney;
};

/**
 * 设置cookie
 * @param {String} sKey cookie的名字
 * @param {String} sValue cookie的值
 * @param {Number | String | Data} vEnd cookie的过期时间
 * @param {String} sPath cookie的所在目录
 * @param {String} sDomain cookie的所在域
 * @param {Boolean} bSecure 是否开启cookie的secure属性
 * @return {Boolean}
 */
export function setCookie(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
    return false;
  }
  var sExpires = "";
  if (vEnd) {
    switch (vEnd.constructor) {
      case Number:
        sExpires =
          vEnd === Infinity
            ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
            : "; max-age=" + vEnd;
        break;
      case String:
        sExpires = "; expires=" + vEnd;
        break;
      case Date:
        sExpires = "; expires=" + vEnd.toUTCString();
        break;
    }
  }
  document.cookie =
    encodeURIComponent(sKey) +
    "=" +
    encodeURIComponent(sValue) +
    sExpires +
    (sDomain ? "; domain=" + sDomain : "") +
    (sPath ? "; path=" + sPath : "") +
    (bSecure ? "; secure" : "");
  return true;
}

export const imgFormater = (val, size = 450) => `${val}?!s${size}.${size}`;

/**
 * 手机号格式化 136 1668 6688
 * @param { String } phone 手机号
 * @return { String } 格式化后手机号
 */
export function formatPhone(phone) {
  if (!phone) return;
  let str = phone.toString().replace(/ /g, "");
  let len = str.length;
  switch (true) {
    // case len > 11:
    //     str = str.substr(0, 3) + ' ' + str.substr(3, 4) + ' ' + str.substr(7, 4);
    //     phone = str;
    //     break;
    case len > 7:
      str = str.substr(0, 3) + " " + str.substr(3, 4) + " " + str.substr(7);
      phone = str;
      break;
    case len > 3:
      str = str.substr(0, 3) + " " + str.substr(3);
      phone = str;
      break;
    default:
      phone = str;
  }
  return phone;
}

/**
 * 身份证格式化 310*** ******** 0089
 * @param { String } idNm 身份证号
 * @return { String } 格式化后身份证号
 */
export function formatIdNum(idNm) {
  idNm = idNm.toUpperCase(); // 字母转大写
  let newIdNum =
    idNm.substring(0, 3) + "*** ******** " + idNm.substring(14, 18);
  return newIdNum;
}

function rad(d) {
  return (d * Math.PI) / 180.0; //经纬度转换成三角函数中度分表形式。
}

/*获取两个地址之间的距离
position：当前所在定位
locationObj：目的地
两个都是经纬度
*/
export function getDistance(position, locationObj) {
  const radLat1 = rad(position.lat);
  const radLat2 = rad(locationObj.lat);
  let a = rad(position.lat) - rad(locationObj.lat);
  let b = rad(position.lng) - rad(locationObj.lng);
  let s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137;
  s = (Math.round(s * 10000) / 10000).toFixed(0); //输出为km
  if (s < 1) {
    return (s = s * 1000 + "m");
  } else {
    return s + "km";
  }
}

/**
 * 获取工会的值
 * @return {String}
 */
// 测试环境：http://corp.m.test03.com/union/lifangfang02/user/login
// stage：https://corp.m.stage.dongfangfuli.com/bfd/home?union=rjh
// 生产：https://corp.m.dongfangfuli.com/bfd/home?union=rjh
export function unionFlag() {
  let currentUnionValue;
  const union = getQueryString("union");
  const { hostname, pathname } = window.location;
  if (union) {
    // URI带union参数的判断是工会链接
    return union;
  }
  if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
    // 测试环境http://corp.m.test03.com/union/lifangfang02/user/login
    currentUnionValue = pathname.match(/union\/\w+/g)[0].split("/")[1];
  } else {
    // 正式环境http://www.dbenefit.dongfangfuli.com/bfd_pc/index?union=dbenefit&city=2
    // 测试环境http://union.testzhou.zhouweiwei.qa.psf-dev.com/
    // k8s测试环境http://www.lifangfang02.test01.com/drama_pc/home?city=145&mc=Shows
    // stage环境http://www.rjh.stage.dongfangfuli.com/shop/home?city=145&mc=Shopping
    if (
      (API_ENV === "test" && /^(?:union)/.test(hostname)) ||
      /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(
        hostname
      )
    ) {
      currentUnionValue = hostname.split(".")[1];
    } else {
      currentUnionValue = "";
    }

    return currentUnionValue;
  }
}

// 乐福小程序埋点
export function getXcxGioName(code) {
  switch (code) {
    case "lfmini":
      return "h5-东福乐福小程序";
    // case 'bfdmini':
    // case 'gwmini':
    // case 'exchangemini':
    default:
      return "h5-微信小程序";
  }
}

/**
 * gio埋点
 * @param { String } eventName // 事件名称
 * @param { Object } params // 参数
 */
export function gioClickHandle(eventName, params, type = "") {
  const now = new Date().getTime();
  let newParams = null;
  switch (type) {
    case "cart":
      newParams = getCartGioParams(eventName, params);
      break;
    default:
      newParams = getGioParams(eventName, params, type);
      break;
  }
  try {
    gio("track", eventName, newParams);
    console.log("newParams...", JSON.stringify(newParams));
  } catch (error) {
    console.log(error);
  }
}

export function getGioParams(eventName, params = {}, type = "") {
  const now = new Date().getTime();
  const address = JSON.parse(getCookie("address")) || {};
  const url = window.parent.location.href;
  const unionF = unionFlag() || sessionStorage.getItem("dffl_union");

  let platformInfo = 'h5';
  const lfFlag = Cookies.get('df_channel_source')
  if (BFD_checkApp()) {
    if (iosMobile()) {
      platformInfo = 'h5-IOS';
    }
    if (AndroidMobile()) {
      platformInfo = 'h5-Android';
    }
  // } else if (window?.DF_getCurrentField()) {
  //   platformInfo = getXcxGioName(window?.DF_getCurrentField())
  } else if (checkXcx()) {
    if (lfFlag && lfFlag == 'lf') {
      platformInfo = 'h5-乐福小程序'
    } else {
      platformInfo = 'h5-微信小程序'
    }
  }

  let paramNew = {
    df_platform: platformInfo,
    df_source: (unionF&&!checkUnifyShop()) ? "百福得" : "官网",
    df_prepagename: url ? url : null,
    df_userid: getCookie("unionUserId") || getCookie('mall_userId'),
    df_city: address.cityName,
    // 兑换平台
    df_ExchangePlatform: getExchangePlatformCode(),
  };
  switch (eventName) {
    case "DF_pageView":
      if (type === "main") {
        paramNew.df_pagename = "活动页";
        paramNew.df_channle = "节日礼包";
        paramNew.df_enteractivitytime = now;
      } else if (type === "channelGio") {
        paramNew.df_source = (unionF&&!checkUnifyShop()) ? "百福得" : "官网";
        paramNew.df_activitytime = farmatDate(
          new Date(),
          "yyyy.MM.dd HH:mm:ss"
        );
        paramNew.df_cityid = "" + address.cityId;
      } else {
        paramNew.df_pagename = "活动页子页面";
        paramNew.df_prepagename = "节日礼包";
        paramNew.df_channle = "节日礼包子页面";
        paramNew.df_enteractivitytime = now;
      }
      break;
    case "DF_elementClick":
      paramNew.df_channle = "节日礼包";
      paramNew.df_pagename = "活动页";
      if (type === "channelGio") {
        paramNew.df_source = (unionF&&!checkUnifyShop()) ? "百福得" : "官网";
        paramNew.df_activitytime = farmatDate(
          new Date(),
          "yyyy.MM.dd HH:mm:ss"
        );
        paramNew.df_cityid = "" + address.cityId;
      } else {
        paramNew.df_activitytime = now;
      }
      break;
    case "DF_exposureEvent":
      paramNew.df_platform = platformInfo;
      paramNew.df_source = (unionF&&!checkUnifyShop()) ? "百福得" : "官网";
      paramNew.df_exposuretime = farmatDate(new Date(), "yyyy.MM.dd HH:mm:ss");
      paramNew.df_activitytime = farmatDate(new Date(), "yyyy.MM.dd HH:mm:ss");
      paramNew.df_cityid = "" + address.cityId;
      break;
  }
  paramNew = Object.assign(paramNew, params);
  console.log(paramNew, "gioparamNew");
  return paramNew;
}
/** 购物车 */
export function getCartGioParams(eventName, params = {}) {
  const now = new Date().getTime();
  const address = JSON.parse(getCookie("address")) || {};
  const url = window.parent.location.href;
  const unionF = unionFlag() || sessionStorage.getItem("dffl_union");

  let platformInfo = 'h5';
  const lfFlag = Cookies.get('df_channel_source')
  if (BFD_checkApp()) {
    if (iosMobile()) {
      platformInfo = 'h5-IOS';
    }
    if (AndroidMobile()) {
      platformInfo = 'h5-Android';
    }
  // } else if (window?.DF_getCurrentField()) {
  //   platformInfo = getXcxGioName(window?.DF_getCurrentField())
  } else if (checkXcx()) {
    if (lfFlag && lfFlag == 'lf') {
      platformInfo = 'h5-乐福小程序'
    } else {
      platformInfo = 'h5-微信小程序'
    }
  }

  let paramNew = {
    df_platform: platformInfo,
    df_source: (unionF&&!checkUnifyShop()) ? "百福得" : "官网",
    df_prepagename: url ? url : null,
    df_userid: getCookie("unionUserId") || getCookie('mall_userId'),
    df_city: address.cityName,
    // 兑换平台
    df_ExchangePlatform: getExchangePlatformCode(),
  };
  switch (eventName) {
    case "DF_elementClick":
      paramNew.df_platform = platformInfo;
      paramNew.df_pagename = "购物车";
      paramNew.df_cityid = "" + address.cityId;
      break;
  }
  paramNew = Object.assign(paramNew, params);
  console.log(paramNew, "gioparamNew");
  return paramNew;
}

/**
 * 获取频道name
 * @param { number } channelId  // 频道ID
 * @return { String }  频道name
 */
export function getChannelName(channelId) {
  let id = Number(channelId);
  switch (id) {
    case 1:
      return "电影";
      break;
    case 2:
      return "优选生活";
      break;
    case 3:
      return "生日汇";
      break;
    case 4:
      return "门票";
      break;
    case 5:
      return "演出";
      break;
    case 6:
      return "运动健身";
      break;
    case 7:
      return "400预定";
      break;
    case 8:
      return "节日礼包";
      break;
    case 9:
      return "特卖会";
      break;
    case 10:
      return "工会活动";
      break;
    case 16:
      return "京东优选";
      break;
    case 17:
      return "东福超市";
      break;
    case 18:
      return "图书";
      break;
    case 20:
      return "小米有品";
      break;
    case 22:
      return "网易严选";
      break;
    case 998:
      return "图书";
      break;
    case 999:
      return "京东优选";
      break;
    default:
      return "优选生活";
      break;
  }
}

/**
 * 时间格式化
 * @param { date } date // 时间
 * @param { string } fmt  // 格式化格式
 * @return { String }  提示文案
 */
export function farmatDate(date, fmt) {
  const o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
  };
  let year = date.getFullYear().toString();
  year = year.length >= 4 ? year : "0000".substr(0, 4 - year.length) + year;

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (year + "").substr(4 - RegExp.$1.length));
  for (const k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

// /**
//  * 日期格式化
//  * @param { date } date // 日期
//  * @return { string } fmtDate  // 格式化日期
//  */
// export function formatDay(date) {
//   let fmtDate = '';
//   let mm = date.getMonth() + 1;
//   let dd = date.getDate();
//   let year = date.getFullYear();
//   if (year != new Date().getFullYear()) {
//     fmtDate = year + TLang('倒计时年', 'goods') + mm + TLang('倒计时月', 'goods') + dd + TLang('倒计时日', 'goods');
//   } else {
//     fmtDate = mm + TLang('倒计时月', 'goods') + dd + TLang('倒计时日', 'goods');
//   }
//   return fmtDate;
// }

export function isMiniprogram() {
  return window.__wxjs_environment === 'miniprogram';
}
/**
 * 错误收集器
 * @param key 标记
 * @param errorMessage 错误信息
 */
export function errorLog(page, key, errorMessage) {
  try {
    if (API_ENV === "production") {
      const error = {
        page: page,
        error: `error - [${key}]`,
        data: errorMessage,
        timelog: new Date().toJSON(),
        cookies: document.cookie,
        localStorage: localStorage,
        sessionStorage: sessionStorage,
      };
      Sentry.withScope((scope) => {
        scope.setExtras(error);
        const eventId = Sentry.captureException(error);
      });
    }
  } catch (e) {
    console.log("error", e);
  }
}

export function getBannerHeight() {
  const width = window.screen.availWidth;
  const rat = 100 / 375;
  const height = rat * width;
  return height;
}

/**
 * iosMobile
 */
export function iosMobile() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && !!u.match(/AppleWebKit.*Mobile.*/);
}

/**
 * AndroidMobile
 */
export function AndroidMobile() {
  const u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

export const appCode = '100049';
export const appSecret = API_ENV === 'production' ? '3bs82jr52e' : '123456';
